<template>
  <div class="annual-general">
    <div class="annual-general-title">
      全年
      <el-select style="width: 128px" class="select-year" v-model="currentYear" @change="changeYear" placeholder="请选择">
        <el-option v-for="item in yearOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </div>
    <div class="wrap-box-tips">
      <div class="allyear-tips">
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              结算项目数量
              <el-tooltip class="item" content="包含在调研工厂完成的问卷调查、明察暗访和导入线下调查数据" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ allYearData.projectNum }}</p>
          </div>
        </div>
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              结算人数/企业
              <el-tooltip class="item" content="合计结算的调查员/代理数量" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ allYearData.investigatorsNum }}</p>
          </div>
        </div>
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              到手金额(元)
              <el-tooltip class="item" content="调查员实际到手金额(扣除服务费税后)" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ allYearData.expectedYuanAmount.toFixed(2) }}</p>
            <!-- <p class="tips-supplement">
              含补扣款 {{allYearData.adjustYuanAmount.toFixed(2) > 0 ? '+' : ''}}{{ allYearData.adjustYuanAmount.toFixed(2) }}
              <el-tooltip class="item"  content="额外给予的补扣款，该补扣款已包含在调查员到手金额中" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p> -->
          </div>
        </div>
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              服务费(元)
              <el-tooltip class="item" content="服务费用于调查员代缴税及平台技术服务费" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ allYearData.serviceYuanAmount.toFixed(2) }}</p>
          </div>
        </div>
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              结算总费用(元)
              <el-tooltip class="item" content="合计花费金额" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ allYearData.operationalYuanAmount.toFixed(2) }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="charts-table">
      <div class="charts-box">
        <yearly-eCharts :cData="chartsData" />
      </div>
      <div class="table-box">
        <el-table :row-class-name="tableRowClassName" :data="tableData" height="300" style="width: 100%">
          <el-table-column :align="'center'" prop="month" label="月份" min-width="44"></el-table-column>
          <el-table-column label="调查员" :align="'center'" :class-name="'orange-theme'">
            <el-table-column
              :align="'right'"
              prop="investigatorsNum"
              label="调查员"
              min-width="58"
              :class-name="'orange-theme'"
            ></el-table-column>
            <el-table-column
              :align="'right'"
              min-width="96"
              prop="expectedYuanAmount"
              label="到手金额(元)"
              :class-name="'orange-theme'"
            ></el-table-column>
            <el-table-column
              :align="'right'"
              min-width="82"
              prop="serviceYuanAmount"
              label="服务费(元)"
              :class-name="'orange-theme'"
            ></el-table-column>
            <el-table-column
              :align="'right'"
              min-width="96"
              prop="operationalYuanAmount"
              label="结算费用(元)"
              :class-name="'orange-theme'"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="代理" :align="'center'" :class-name="'bule-theme'">
            <el-table-column :align="'right'" min-width="68" prop="agentNum" label="代理" :class-name="'bule-theme'">
            </el-table-column>
            <el-table-column
              :align="'right'"
              min-width="96"
              prop="operationalAgentYuanAmount"
              label="结算费用(元)"
              :class-name="'bule-theme'"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column
            :align="'right'"
            prop="operationalAllYuanAmount"
            label="结算总费用(元)"
            min-width="110"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="annual-general-title">结算概况</div>
    <div class="wrap-box-tips">
      <div class="all-tabs-date">
        <div class="wrap-tabs">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item, i) in tabsArr" :key="i" :label="item.label" :name="item.name"></el-tab-pane>
          </el-tabs>
          <el-tabs style="margin-left: 30px" v-model="activeProxyName" @tab-click="handleClickProxy">
            <el-tab-pane v-for="(item, i) in tabsProxyArr" :key="i" :label="item.label" :name="item.name"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="right-data-btns">
          <div class="date-search">
            <span style="font-size: 14px; font-weight: 400; margin-right: 10px">时间筛选:</span>
            <div
              @click="changeButton(item)"
              :class="item.active === true ? 'buttons-style active' : 'buttons-style'"
              v-for="(item, i) in buttons"
              :key="i"
            >
              {{ item.label }}
            </div>
            <el-date-picker
              v-model="date"
              type="daterange"
              align="right"
              style="width: 238px; margin-left: 12px"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <el-button style="margin-left: 12px" type="primary" @click="search()">搜索</el-button>
            <el-button style="margin-right: 16px" type="primary" plain @click="reset()">重置</el-button>
          </div>
        </div>
      </div>
      <!-- <div class="allyear-tips">
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              关联调查数据
              <el-tooltip
                class="item"
                
                content="包含在调研工厂完成的问卷调查、明察暗访和导入线下调查数据"
                placement="top"
              >
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ settleOverviewData.projectNum }}</p>
          </div>
        </div>
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              结算调查员人数
              <el-tooltip class="item"  content="选中结算项目中的调查员" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ settleOverviewData.investigatorsNum }}</p>
          </div>
        </div>
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              到手金额(元)
              <el-tooltip class="item"  :content="`调查员实际到手金额（已扣除${accountingRateVal} ）`" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ settleOverviewData.expectedYuanAmount.toFixed(2) }}</p>
            <p class="tips-supplement">
              含补扣款 {{settleOverviewData.adjustYuanAmount.toFixed(2) > 0 ? '+' : ''}}{{ settleOverviewData.adjustYuanAmount.toFixed(2) }}
              <el-tooltip class="item"  content="额外给予的补扣款，该补扣款已包含在调查员到手金额中" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
          </div>
        </div>
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              服务费(元)
              <el-tooltip class="item"  :content="`服务费为 ${accountingRateVal} 用于调查员代缴税及平台技术服务费`" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ settleOverviewData.serviceYuanAmount.toFixed(2) }}</p>
          </div>
        </div>
        <div class="allyear-tips-item">
          <div class="item-tips">
            <p>
              结算总费用(元)
              <el-tooltip class="item"  content="调查员到手金额+服务费为结算总费用" placement="top">
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
              </el-tooltip>
            </p>
            <p class="tips-nums">{{ settleOverviewData.operationalYuanAmount.toFixed(2) }}</p>
          </div>
        </div>
      </div> -->
      <div class="allyear-table">
        <el-table
          ref="allyearTableRef"
          size="medium"
          class="allyear-table-style"
          :border="true"
          :data="allyearTableData"
          max-height="200"
          style="width: 100%"
        >
          <el-table-column
            label="调查员"
            v-if="activeProxyName === '2' || activeProxyName === '0'"
            :align="'center'"
            :class-name="'orange-theme'"
          >
            <el-table-column
              :class-name="'orange-theme'"
              :align="'right'"
              v-if="activeProxyName === '2' || activeProxyName === '0'"
              prop="projectNum"
              label="关联项目数"
              min-width="128"
            >
              <template slot="header">
                <div style="display: flex; justify-content: end">
                  关联项目数量
                  <el-tooltip class="item" content="在调研工厂完成的问卷调查、明察暗访和线下执行的调查数据" placement="top">
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :class-name="'orange-theme'"
              :align="'right'"
              v-if="activeProxyName === '2' || activeProxyName === '0'"
              min-width="99"
              prop="investigatorsNum"
              label="结算人数"
            >
              <template slot="header">
                <div style="display: flex; justify-content: end">
                  结算人数
                  <el-tooltip class="item" content="该项目包含的调查员人数" placement="top">
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :class-name="'orange-theme'"
              :align="'right'"
              v-if="activeProxyName === '2' || activeProxyName === '0'"
              min-width="141"
              prop="expectedYuanAmount"
              label="到手金额（元)"
            >
              <template slot="header">
                <div :style="{ display: 'flex', justifyContent: 'end' }">
                  到手金额(元)
                  <el-tooltip class="item" content="调查员实际到手金额（扣除服务费税后)" placement="top">
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="{ row }">
                <div>
                  <p>{{ row.expectedYuanAmount }}</p>
                  <div style="display: flex; justify-content: end; color: #e8a31b; font-size: 12px">
                    含补扣款{{ row.adjustYuanAmount > 0 ? '+' : '' }}{{ row.adjustYuanAmount }}
                    <el-tooltip
                      class="item"
                      content="根据调查实际情况，给调查员补扣相应款项，补扣款将计入调查员到手金额"
                      placement="top"
                    >
                      <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :class-name="'orange-theme'"
              :align="'right'"
              v-if="activeProxyName === '2' || activeProxyName === '0'"
              min-width="109"
              prop="serviceYuanAmount"
              label="服务费(元)"
            >
              <template slot="header">
                <div style="display: flex; justify-content: end">
                  服务费(元)
                  <el-tooltip class="item" content="服务费用于调查员代缴税及平台技术服务费" placement="top">
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :class-name="'orange-theme'"
              :align="'right'"
              v-if="activeProxyName === '2' || activeProxyName === '0'"
              min-width="138"
              prop="operationalYuanAmount"
              label="调查员结算总费用（元)"
            >
              <template slot="header">
                <div style="display: flex; justify-content: end">
                  结算总费用(元)
                  <el-tooltip class="item" content="结算费用 = 调查员到手金额 + 服务费，即实际执行成本" placement="top">
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            v-if="activeProxyName === '1' || activeProxyName === '0'"
            label="代理"
            :align="'center'"
            :class-name="'bule-theme'"
          >
            <el-table-column
              v-if="activeProxyName === '1' || activeProxyName === '0'"
              :align="'right'"
              min-width="128"
              prop="projectAgentNum"
              label="关联项目数量"
              :class-name="'bule-theme'"
            >
              <template slot="header">
                <div style="display: flex; justify-content: end">
                  关联项目数量
                  <el-tooltip class="item" content="在调研工厂完成的问卷调查、明察暗访和线下执行的调查数据" placement="top">
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="activeProxyName === '1' || activeProxyName === '0'"
              :align="'right'"
              min-width="128"
              prop="agentNum"
              label="结算企业数量"
              :class-name="'bule-theme'"
            >
              <template slot="header">
                <div style="display: flex">
                  结算企业数量
                  <el-tooltip class="item" content="该项目包含的的代理数量" placement="top">
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="activeProxyName === '1' || activeProxyName === '0'"
              :align="'right'"
              min-width="138"
              prop="operationalAgentYuanAmount"
              label="结算总费用(元)"
              :class-name="'bule-theme'"
            >
              <template slot="header">
                <div style="display: flex">
                  结算总费用(元)
                  <el-tooltip class="item" content="代理的结算总费用" placement="top">
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="{ row }">
                <div>
                  <p>{{ row.operationalAgentYuanAmount }}</p>
                  <div style="display: flex; justify-content: end; color: #e8a31b; font-size: 12px">
                    含补扣款{{ row.adjustYuanAgentAmount > 0 ? '+' : '' }}{{ row.adjustYuanAgentAmount || '0.00' }}
                    <el-tooltip
                      class="item"
                      content="根据调查实际情况，给代理补扣相应款项，补扣款将计入代理到手金额"
                      placement="top"
                    >
                      <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            v-if="activeProxyName === '0'"
            :align="'right'"
            prop="projectAllNum"
            label="关联项目数量"
            min-width="144"
          >
            <template slot="header">
              <div style="display: flex">
                关联项目数量
                <el-tooltip class="item" content="合计结算的调查员 / 代理数量" placement="top">
                  <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeProxyName === '0'"
            :align="'right'"
            prop="operationalAllYuanAmount"
            label="结算总费用"
            min-width="130"
          >
            <template slot="header">
              <div style="display: flex">
                结算总费用
                <el-tooltip class="item" content="合计花费金额" placement="top">
                  <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-2"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="table-list">
      <div v-for="item in allTableOptions" :key="item.key">
        <table-list
          :table-key="item.key"
          :tableData="item.tableData"
          :columnData="item.columnData"
          :lastColumn="item.lastColumn"
          :projectTitle="item.projectTitle"
          :processColor="item.processColor"
          :loading="item.loading"
          :search-date="searchDate"
          @emitSortChange="changeSort"
        />
      </div>
    </div>
    <!-- 网站协议文案提示 -->
    <DygcFooter class="my-2" />
  </div>
</template>

<script>
import YearlyECharts from './YearlyECharts.vue'
import SettleChart from './SettleChart'
import TableList from '@/views/home/cost-settlement/settlement-statistics/TableList.vue'
import {
  getSettleStatisticsYear,
  getAllSettleStatistics,
  getProject,
  getDept,
  getInvestigator,
  getForCreate,
  getProjectType,
  getAllYears
} from '@/api/cost-settlement/annual-general.js'
import DygcFooter from 'components/dygc-footer-bottom/index'

export default {
  name: 'settlementStatistics',
  components: { YearlyECharts, TableList, DygcFooter },
  props: {},
  data() {
    return {
      currentYear: new Date().getFullYear().toString(),
      yearOptions: [{ label: '2022年', value: '2022' }],
      tabsArr: [
        { label: '全部', name: '0' },
        { label: '待审批', name: '1' },
        { label: '待支付', name: '2' },
        { label: '已支付', name: '3' }
      ],
      tabsProxyArr: [
        { label: '全部', name: '0' },
        { label: '代理', name: '1' },
        { label: '调查员', name: '2' }
      ],
      buttons: [
        { value: 'all', label: '全部' },
        { value: 'year', label: '本年', active: true },
        { value: 'month', label: '本月' },
        { value: 'week', label: '本周' },
        { value: 'day', label: '当日' }
      ],
      // 全年数据
      allYearData: {
        adjustYuanAmount: 0, //黄字 扣款
        projectNum: 0, //结算项目总数量 | 管理调查数据
        investigatorsNum: 0, //调查员人数
        expectedYuanAmount: 0, //到手金额
        serviceYuanAmount: 0, //服务费
        operationalYuanAmount: 0 //结算总费用
      },
      // 结算概况数据
      settleOverviewData: {
        projectNum: 0, //结算项目总数量 | 管理调查数据
        adjustYuanAmount: 0,
        investigatorsNum: 0, //调查员人数
        expectedYuanAmount: 0, //到手金额
        serviceYuanAmount: 0, //服务费
        operationalYuanAmount: 0 //结算总费用
      },
      // 折线图数据
      chartsData: [],
      // 全年表格数据
      tableData: [],
      // 项目表格
      projectOptions: {
        key: 'bySettleName',
        tableData: [],
        columnData: [
          { key: 'settleName', label: '结算项目名称', align: 'left', width: '126px', isShow: true },
          { key: 'settleDept', label: '所属部门', align: 'left', width: '124px', isShow: true },
          {
            key: 'investigatorWrap',
            label: '调查员',
            className: 'orange-theme',
            align: 'center',
            isShow: true,
            children: [
              {
                key: 'investigatorsNum',
                label: '结算人数',
                align: 'right',
                width: '101px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'expectedYuanAmount',
                label: '到手金额(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'serviceYuanAmount',
                label: '服务费(元)',
                align: 'right',
                width: '111px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'operationalYuanAmount',
                label: '结算费用(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              }
            ]
          },
          {
            key: 'proxyWrap',
            label: '代理',
            className: 'bule-theme',
            align: 'center',
            isShow: true,
            children: [
              {
                key: 'agentNum',
                label: '结算企业数量',
                align: 'right',
                width: '129px',
                sortable: true,
                isBold: true,
                className: 'bule-theme'
              },
              {
                key: 'operationalAgentYuanAmount',
                label: '结算费用(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'bule-theme'
              }
            ]
          }
        ],
        lastColumn: { key: 'operationalAllYuanAmount', label: '结算总费用(元)', isShow: true },
        projectTitle: '按项目',
        processColor: '#2775E8',
        loading: false
      },
      // 部门表格
      deptOptions: {
        key: 'bySettleDept',
        tableData: [],
        columnData: [
          { key: 'settleDept', label: '所属部门', align: 'left', width: '126px', isShow: true },
          { key: 'projectNum', label: '结算项目数', align: 'right', width: '124px', sortable: true, isBold: true, isShow: true },
          {
            key: 'investigatorWrap',
            label: '调查员',
            className: 'orange-theme',
            align: 'center',
            isShow: true,
            children: [
              {
                key: 'investigatorsNum',
                label: '结算人数',
                align: 'right',
                width: '101px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'expectedYuanAmount',
                label: '到手金额(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'serviceYuanAmount',
                label: '服务费(元)',
                align: 'right',
                width: '111px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'operationalYuanAmount',
                label: '结算费用(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              }
            ]
          },
          {
            key: 'proxyWrap',
            label: '代理',
            className: 'bule-theme',
            align: 'center',
            isShow: true,
            children: [
              {
                key: 'agentNum',
                label: '结算企业数量',
                align: 'right',
                width: '129px',
                sortable: true,
                isBold: true,
                className: 'bule-theme'
              },
              {
                key: 'operationalAgentYuanAmount',
                label: '结算费用(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'bule-theme'
              }
            ]
          }
        ],
        lastColumn: { key: 'operationalAllYuanAmount', label: '结算总费用(元)', isShow: true },
        projectTitle: '按部门',
        processColor: '#E8A31B',
        loading: false
      },
      // 按调查员表格
      investigatorOptions: {
        key: 'bySettleObjType',
        tableData: [
          {
            id: '1',
            investigatorName: '张三',
            investigatorsNum: 300,
            expectedYuanAmount: 1000,
            serviceYuanAmount: 100,
            operationalYuanAmount: 3000,
            percentage: '100%'
          }
        ],
        columnData: [
          {
            key: 'investigatorName',
            label: '调查员/代理',
            className: 'orange-theme',
            align: 'left',
            width: '538px',
            isShow: true
          },
          { key: 'projectNum', label: '结算项目数', align: 'right', width: '175px', sortable: true, isBold: true, isShow: true },
          // { key: 'investigatorsNum', label: '结算调查员人数', align: 'right', width: 175, sortable: true, isBold: true },
          {
            key: 'expectedYuanAmount',
            label: '到手金额(元)',
            align: 'right',
            width: '125px',
            sortable: true,
            isBold: true,
            isShow: true
          },
          {
            key: 'serviceYuanAmount',
            label: '服务费(元)',
            align: 'right',
            width: '124px',
            sortable: true,
            isBold: true,
            isShow: true
          }
        ],
        lastColumn: { key: 'operationalYuanAmount', label: '结算总费用(元)', isShow: true },
        projectTitle: '按调查员/代理',
        processColor: '#E34152',
        loading: false
      },
      // 按发起人
      creatorOptions: {
        key: 'byCreatorName',
        tableData: [],
        columnData: [
          { key: 'creatorName', label: '发起人', align: 'left', width: '126px', isShow: true },
          { key: 'projectNum', label: '结算项目数', align: 'right', width: '124px', sortable: true, isBold: true, isShow: true },
          {
            key: 'investigatorWrap',
            label: '调查员',
            className: 'orange-theme',
            align: 'center',
            isShow: true,
            children: [
              {
                key: 'investigatorsNum',
                label: '结算人数',
                align: 'right',
                width: '101px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'expectedYuanAmount',
                label: '到手金额(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'serviceYuanAmount',
                label: '服务费(元)',
                align: 'right',
                width: '111px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'operationalYuanAmount',
                label: '结算费用(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              }
            ]
          },
          {
            key: 'proxyWrap',
            label: '代理',
            className: 'bule-theme',
            align: 'center',
            isShow: true,
            children: [
              {
                key: 'agentNum',
                label: '结算企业数量',
                align: 'right',
                width: '129px',
                sortable: true,
                isBold: true,
                className: 'bule-theme'
              },
              {
                key: 'operationalAgentYuanAmount',
                label: '结算费用(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'bule-theme'
              }
            ]
          }
        ],
        lastColumn: { key: 'operationalAllYuanAmount', label: '结算总费用(元)', isShow: true },
        projectTitle: '按发起人',
        processColor: '#00BE6A',
        loading: false
      },
      // 按项目类型
      projectTypeOptions: {
        key: 'byProjectCategory',
        tableData: [],
        columnData: [
          { key: 'projectType', label: '结算类型', align: 'left', width: '126px', isShow: true },
          { key: 'projectNum', label: '结算项目数', align: 'right', width: '124px', sortable: true, isBold: true, isShow: true },
          {
            key: 'investigatorWrap',
            label: '调查员',
            className: 'orange-theme',
            align: 'center',
            isShow: true,
            children: [
              {
                key: 'investigatorsNum',
                label: '结算人数',
                align: 'right',
                width: '101px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'expectedYuanAmount',
                label: '到手金额(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'serviceYuanAmount',
                label: '服务费(元)',
                align: 'right',
                width: '111px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              },
              {
                key: 'operationalYuanAmount',
                label: '结算费用(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'orange-theme'
              }
            ]
          },
          {
            key: 'proxyWrap',
            label: '代理',
            className: 'bule-theme',
            align: 'center',
            isShow: true,
            children: [
              {
                key: 'agentNum',
                label: '结算企业数量',
                align: 'right',
                width: '129px',
                sortable: true,
                isBold: true,
                className: 'bule-theme'
              },
              {
                key: 'operationalAgentYuanAmount',
                label: '结算费用(元)',
                align: 'right',
                width: '125px',
                sortable: true,
                isBold: true,
                className: 'bule-theme'
              }
            ]
          }
        ],
        lastColumn: { key: 'operationalAllYuanAmount', label: '结算总费用(元)', isShow: true },
        projectTitle: '按项目类型',
        processColor: '#00BE6A',
        loading: false
      },
      activeName: '0',
      activeProxyName: '0',
      pickerOptions: {
        disabledDate(time) {
          let curDateYear = new Date().getFullYear() // 当前时间的年份
          let oneYearAgoDate = new Date(curDateYear, 0, 1)
          let oneYear = new Date(oneYearAgoDate).getTime() //一年前字符串转为时间戳
          // return time.getTime() > Date.now() || time.getTime() < oneYear
          return time.getTime() > Date.now() 
        }
      },
      date: ['', '']
    }
  },
  watch: {},
  computed: {
    searchDate() {
      return [
        this.DateToStr(new Date(this.date[0])),
        this.DateToStr(new Date(this.date[1]))
      ]
    },
    allTableOptions() {
      return [this.projectOptions, this.deptOptions, this.investigatorOptions, this.creatorOptions, this.projectTypeOptions]
    },
    // 计算 结算概况table数据
    allyearTableData() {
      // 获取所有字段的值 存放在Array 中 后期进行判断 只有有一个非0  则显示数据 否则显示暂无数据
      let catchResObj = []
      const cloneSettleData = { ...this.settleOverviewData }
      // 循环判断调查员对象部分字段保留两位小数
      for (let key in cloneSettleData) {
        if (
          key === 'expectedYuanAmount' ||
          key === 'serviceYuanAmount' ||
          key === 'operationalYuanAmount' ||
          key === 'adjustYuanAmount' ||
          key === 'operationalAgentYuanAmount' ||
          key === 'adjustYuanAgentAmount'
        ) {
          cloneSettleData[key] = Number(cloneSettleData[key]).toFixed(2)
        }
      }
      const resObj = { ...cloneSettleData }
      let isEmpty = false
      for (let key in resObj) {
        resObj[key] = resObj[key] || 0
        // console.log(' resObj[key] :', resObj[key], typeof resObj[key])
        catchResObj.push(resObj[key])
      }
      isEmpty = catchResObj.map(i => Number(i)).some(i => i > 0)

      return isEmpty ? [{ ...resObj }] : []
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
  },
  methods: {
    // 高亮当前月份
    tableRowClassName({ row, rowIndex }) {
      if (row.month * 1 === new Date().getMonth() + 1 && this.currentYear * 1 === new Date().getFullYear()) {
        return 'hight-row'
      }
      return ''
    },
    // 日期选择
    getChange(picker) {
      let end = new Date()
      let start = new Date()
      switch (picker) {
        // 全部
        case 'all':
          end = ''
          start = ''
          break
        // 本周
        case 'week':
          end = new Date()
          start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          break
        // 本月
        case 'month':
          end = new Date()
          start = new Date(end.getFullYear(), end.getMonth(), 1)
          start.setTime(start.getTime())
          break
        // 本年
        case 'year':
          end = new Date()
          start = new Date(end.getFullYear(), 0, 1)
          start.setTime(start.getTime())
          break
        // 当日
        case 'day':
          end = new Date()
          start = new Date()
          break
      }
      this.date = [start, end]
    },
    DateToStr(date) {
      if (date !== '') {
        var year = date.getFullYear() //年
        var month = date.getMonth() //月
        var day = date.getDate() //日
        var hours = date.getHours() //时
        var min = date.getMinutes() //分
        var second = date.getSeconds() //秒
        return year + '-' + (month + 1 > 9 ? month + 1 : '0' + (month + 1)) + '-' + (day > 9 ? day : '0' + day)
        //   + " " +
        //  (hours > 9 ? hours : ("0" + hours)) + ":" +
        //  (min > 9 ? min : ("0" + min)) + ":" +
        //  (second > 9 ? second : ("0" + second));
      } else {
        return ''
      }
    },
    // 重置
    reset() {
      this.date = ['', '']
      // this.activeName = '0'
      this.buttons = [...this.buttons].map(it => ({ ...it, active: it.label === '本年' ? true : false }))
      this.getChange('year')
      this.activeName = '0'
      this.activeProxyName = '0'
      this.getAllData(this.activeName, this.activeProxyName)
      this.getTableData(getProject, this.activeName, this.activeProxyName, this.projectOptions)
      this.getTableData(getDept, this.activeName, this.activeProxyName, this.deptOptions)
      this.getTableData(getInvestigator, this.activeName, this.activeProxyName, this.investigatorOptions)
      this.getTableData(getForCreate, this.activeName, this.activeProxyName, this.creatorOptions)
      this.getTableData(getProjectType, this.activeName, this.activeProxyName, this.projectTypeOptions)
    },
    // 查询
    search() {
      // if (this.date instanceof Array && this.date.length > 0 && !this.date.includes('')) {

      this.getAllData(this.activeName, this.activeProxyName)
      this.getTableData(getProject, this.activeName, this.activeProxyName, this.projectOptions)
      this.getTableData(getDept, this.activeName, this.activeProxyName, this.deptOptions)
      this.getTableData(getInvestigator, this.activeName, this.activeProxyName, this.investigatorOptions)
      this.getTableData(getForCreate, this.activeName, this.activeProxyName, this.creatorOptions)
      this.getTableData(getProjectType, this.activeName, this.activeProxyName, this.projectTypeOptions)
      // } else {
      //   this.$message.error('请选择日期')
      // }
    },
    changeButton(row) {
      const postData = [...this.buttons]
      postData.forEach(item => {
        if (row.value === item.value) {
          item.active = true
        } else {
          item.active = false
        }
      })
      this.buttons = postData
      this.getChange(row.value)
      this.search()
    },
    handleClick(tab, event) {
      this.getAllData(tab.name, this.activeProxyName)
      this.getTableData(getProject, tab.name, this.activeProxyName, this.projectOptions)
      this.getTableData(getDept, tab.name, this.activeProxyName, this.deptOptions)
      this.getTableData(getInvestigator, tab.name, this.activeProxyName, this.investigatorOptions)
      this.getTableData(getForCreate, tab.name, this.activeProxyName, this.creatorOptions)
      this.getTableData(getProjectType, tab.name, this.activeProxyName, this.projectTypeOptions)
    },
    // 切换代理的导航条
    handleClickProxy(tab, event) {
      const cloneAllTableOptions = JSON.parse(JSON.stringify(this.allTableOptions))
      const filterAllTable = cloneAllTableOptions.filter(it => it.projectTitle !== '按调查员/代理')

      // console.log(cloneAllTableOptions, filterAllTable)

      filterAllTable.forEach(item => {
        item.columnData.forEach(it => {
          //tab.name 1 代理 2 调查员
          if (tab.name === '1') {
            it.isShow = it.key === 'proxyWrap' ? true : false
            this.$set(this.investigatorOptions, 'projectTitle', '按代理')
            this.$set(this.investigatorOptions, 'columnData', [
              ...this.investigatorOptions.columnData.map(it => ({
                ...it,
                label: it.key === 'investigatorName' ? '代理' : it.label
              }))
            ])
          } else if (tab.name === '2') {
            it.isShow = it.key === 'investigatorWrap' ? true : false
            this.$set(this.investigatorOptions, 'projectTitle', '按调查员')
            this.$set(this.investigatorOptions, 'columnData', [
              ...this.investigatorOptions.columnData.map(it => ({
                ...it,
                label: it.key === 'investigatorName' ? '调查员' : it.label
              }))
            ])
          } else if (tab.name === '0') {
            it.isShow = true
            this.$set(this.investigatorOptions, 'projectTitle', '按调查员/代理')
            this.$set(this.investigatorOptions, 'columnData', [
              ...this.investigatorOptions.columnData.map(it => ({
                ...it,
                label: it.key === 'investigatorName' ? '按调查员/代理' : it.label
              }))
            ])
          }
        })
        // 当切换为 全部时 显示其余项
        tab.name === '0' ? (item.lastColumn.isShow = true) : (item.lastColumn.isShow = false)
      })

      this.projectOptions = filterAllTable.find(it => it.projectTitle === '按项目')
      this.deptOptions = filterAllTable.find(it => it.projectTitle === '按部门')
      this.creatorOptions = filterAllTable.find(it => it.projectTitle === '按发起人')
      this.projectTypeOptions = filterAllTable.find(it => it.projectTitle === '按项目类型')

      this.getAllData(this.activeName, tab.name)
      this.getTableData(getProject, this.activeName, tab.name, this.projectOptions)
      this.getTableData(getDept, this.activeName, tab.name, this.deptOptions)
      this.getTableData(getInvestigator, this.activeName, tab.name, this.investigatorOptions)
      this.getTableData(getForCreate, this.activeName, tab.name, this.creatorOptions)
      this.getTableData(getProjectType, this.activeName, tab.name, this.projectTypeOptions)

      setTimeout(() => {
        this.$refs['allyearTableRef'].doLayout()
      })
    },
    // 获取各大表格数据公共方法
    getTableData(service, tabName, proxyTabName, currentOptions, orderObj = null) {
      currentOptions.loading = true
      let postSortData = {}
      if (orderObj && orderObj.order === 'ascending' && orderObj.prop) {
        postSortData = {
          asc: orderObj.prop
        }
      } else if (orderObj && orderObj.order === 'descending' && orderObj.prop) {
        postSortData = {
          desc: orderObj.prop
        }
      }
      service({
        ...this.handleRequestParams(tabName, proxyTabName),
        ...postSortData
      }).then(({ data }) => {
        if (data.code === 0) {
          data.data.forEach(it => {
            if (it.projectType) {
              switch (it.projectType) {
                case '问卷调查':
                  it.processColor = '#2775E8'
                  break
                case '明察暗访':
                  it.processColor = '#E8A31B'
                  break
                case '人工导入':
                  it.processColor = '#E34152'
                  break
                default:
                  it.processColor = '#2775E8'
                  break
              }
            } else if (it.creatorName && it.investigatorPhone) {
              it.creatorName = it.creatorName + '-' + it.investigatorPhone
            }
          })
          currentOptions.tableData = data.data.map(it => {
            for (let key in it) {
              if (['expectedYuanAmount', 'serviceYuanAmount', 'operationalYuanAmount'].includes(key)) {
                it[key] = it[key].toFixed(2)
                // console.log(it[key])
                if (it[key] === '0.00' && service === getInvestigator && it.isOperational === 1) {
                  it[key] = '-'
                }
              } else if (key !== 'id') {
                it[key] = it[key] ? it[key] : '0'
              }
            }
            return it
            // {...it,
            // expectedYuanAmount:it.expectedYuanAmount.toFixed(2),
            // serviceYuanAmount:it.serviceYuanAmount.toFixed(2),
            // operationalYuanAmount:it.operationalYuanAmount.toFixed(2)
            // }
          })
          currentOptions.loading = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 处理请求参数
    handleRequestParams(tabName, proxyTabName) {
      // if (this.date.includes('')) {
      //   this.getChange('month')
      // }

      let postData = {}
      if (this.date.includes('')) {
        postData = {
          tabId: tabName || this.activeName,
          type: proxyTabName || this.activeProxyName
        }
      } else {
        postData = {
          createTimeStart: this.DateToStr(new Date(this.date[0])),
          createTimeEnd: this.DateToStr(new Date(this.date[1])),
          tabId: tabName || this.activeName,
          type: proxyTabName || this.activeProxyName
        }
      }
      return postData
    },
    // 获取结算汇总
    getAllData(tabName, proxyTabName) {
      getAllSettleStatistics({
        ...this.handleRequestParams(tabName, proxyTabName)
      }).then(({ data }) => {
        if (data.code === 0) {
          this.settleOverviewData = data.data
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    changeYear(val) {
      // console.log(val)
      this.getInit(val)
    },
    // 获取全年数据
    getInit(year = new Date().getFullYear().toString()) {
      getSettleStatisticsYear({
        year
      }).then(({ data }) => {
        // console.log(data)
        if (data.code === 0) {
          // 全年结算概况数据
          this.allYearData = data.data
          // 右侧显示的table数据
          data.data.settleStatisticsMonth.forEach(it => {
            it.expectedYuanAmount = it.expectedYuanAmount.toFixed(2)
            it.serviceYuanAmount = it.serviceYuanAmount.toFixed(2)
            it.operationalYuanAmount = it.operationalYuanAmount.toFixed(2)
            it.agentNum = it.agentNum || 0
            it.operationalAgentYuanAmount = it.operationalAgentYuanAmount || 0
            it.operationalAllYuanAmount = it.operationalAllYuanAmount || 0
            // it.month = it.month
          })
          this.tableData = data.data.settleStatisticsMonth
          // 处理后传给echart的折线图数据
          const seriesData = this.tableData
            .filter(it => it.month !== '合计')
            .map(it => ({ operationalAllYuanAmount: it.operationalAllYuanAmount }))
            .map(it => Object.values(it))
            .flat()
          // 设置echart的数据
          // const month =  this.tableData ? parseInt(this.tableData[0].month):1;
          // if(seriesData.length<month){
          //   for(let i=1;i<month;i++){
          //     seriesData.unshift('');
          //   }
          // }
          // console.log(
          //   'seriesData',
          //   seriesData,
          //   this.tableData.filter(it => it.month !== '合计')
          // )
          this.chartsData = seriesData
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    getYearData() {
      getAllYears().then(({ data }) => {
        if (data.code === 0) {
          // console.log(data.data)
          let OptionsArr = []
          data.data.forEach(it => {
            OptionsArr.push({
              label: `${it}年`,
              value: String(it)
            })
          })
          this.yearOptions = OptionsArr
        }
      })
    },
    // 带字段排序查询
    changeTableSort() {},
    changeSort(prop, order, projectTitle) {
      // console.log(prop, order, projectTitle)
      // this.getTableData(getProject, tab.name, this.projectOptions)
      // this.getTableData(getDept, tab.name, this.deptOptions)
      // this.getTableData(getInvestigator, tab.name, this.investigatorOptions)
      // this.getTableData(getForCreate, tab.name, this.creatorOptions)
      // this.getTableData(getProjectType, tab.name, this.projectTypeOptions)
      const orderObj = { order, prop }
      if (orderObj.prop === 'expectedYuanAmount') {
        orderObj.prop = 'expectedAmount'
      } else if (orderObj.prop === 'serviceYuanAmount') {
        orderObj.prop = 'serviceAmount'
      } else if (orderObj.prop === 'operationalYuanAmount') {
        orderObj.prop = 'operationalAmount'
      } else if (orderObj.prop === 'operationalAgentYuanAmount') {
        orderObj.prop = 'operationalAgentAmount'
      } else if (orderObj.prop === 'operationalAllYuanAmount') {
        orderObj.prop = 'operationalAllAmount'
      }
      switch (projectTitle) {
        case '按项目':
          this.getTableData(getProject, this.activeName, this.activeProxyName, this.projectOptions, orderObj)
          break
        case '按部门':
          this.getTableData(getDept, this.activeName, this.activeProxyName, this.deptOptions, orderObj)
          break
        case '按调查员/代理':
          this.getTableData(getInvestigator, this.activeName, this.activeProxyName, this.investigatorOptions, orderObj)
          break
        case '按发起人':
          this.getTableData(getForCreate, this.activeName, this.activeProxyName, this.creatorOptions, orderObj)
          break
        case '按项目类型':
          this.getTableData(getProjectType, this.activeName, this.activeProxyName, this.projectTypeOptions, orderObj)
          break

        default:
          break
      }
    }
  },
  created() {
    this.getChange('year')
    this.getInit()
    this.getAllData()
    this.getYearData()
    // this.getTableData();
    this.getTableData(getProject, this.activeName, this.activeProxyName, this.projectOptions)
    this.getTableData(getDept, this.activeName, this.activeProxyName, this.deptOptions)
    this.getTableData(getInvestigator, this.activeName, this.activeProxyName, this.investigatorOptions)
    this.getTableData(getForCreate, this.activeName, this.activeProxyName, this.creatorOptions)
    this.getTableData(getProjectType, this.activeName, this.activeProxyName, this.projectTypeOptions)
  },
  mounted() {
    // console.log(this.allTableOptions)
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__item {
  font-size: 15px;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none !important;
}
::v-deep .el-tabs__item {
  height: 47px;
  line-height: 47px;
  font-size: 14px;
  padding: 0 8px;
}
::v-deep .select-year.el-select {
  .el-input.el-input--small.el-input--suffix {
    input.el-input__inner {
      background: #fff;
    }
  }
}
::v-deep .el-table .hight-row .cell {
  color: var(--theme-color) !important;
  font-weight: bold;
}
::v-deep .table-list .el-table .el-table__row .is-right.el-table__cell .cell {
  padding-right: 30px;
}
::v-deep .table-box .el-table .el-table__row .cell {
  font-family: 'PingFangSC';
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  padding-left: 8px;
  padding-right: 8px;
}
::v-deep .table-box .el-table .el-table__header-wrapper .cell {
  font-family: 'PingFangSC';
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  padding-left: 8px;
  padding-right: 8px;
}
::v-deep .table-box .el-table thead.is-group th.el-table__cell {
  background: #f5f5f5;
}
::v-deep .table-box .el-table thead.is-group th.orange-theme.el-table__cell {
  background: rgba(0, 190, 106, 0.1);
}
::v-deep .table-box .el-table thead.is-group th.bule-theme.el-table__cell {
  background: rgba(232, 163, 27, 0.1);
}
::v-deep .table-list .el-table thead.is-group th.orange-theme.el-table__cell {
  background: rgba(0, 190, 106, 0.1);
}
::v-deep .table-list .el-table thead.is-group th.bule-theme.el-table__cell {
  background: rgba(232, 163, 27, 0.1);
}

::v-deep .table-list .el-table thead tr th {
  background: #f5f5f5;
}
::v-deep .table-list .project-title {
  margin-bottom: 16px;
}
::v-deep .table-list .el-table tbody .el-table__cell .cell {
  min-height: 23px;
}
::v-deep .table-list .el-table__body-wrapper.is-scrolling-left {
  min-height: 220px !important;
}
::v-deep .table-list .el-table__body-wrapper.is-scrolling-middle {
  min-height: 220px !important;
}
::v-deep .table-list .el-table__body-wrapper.is-scrolling-right {
  min-height: 220px !important;
}
::v-deep .table-list .el-table--scrollable-y .el-table__body-wrapper {
  height: 220px !important;
}
::v-deep .allyear-table-style.el-table {
  tbody .el-table__cell .cell {
    min-height: 23px;
  }
  thead.is-group th.orange-theme.el-table__cell {
    background: rgba(0, 190, 106, 0.1);
  }
  thead.is-group th.bule-theme.el-table__cell {
    background: rgba(232, 163, 27, 0.1);
  }
  thead.is-group th.el-table__cell {
    background: #f5f5f5;
  }
  th.el-table__cell > .cell {
    padding-left: 8px;
    padding-right: 8px;
    font-weight: 400;
    font-size: 14px;
    i.ml-2.item {
      margin-left: 4px;
    }
  }
}

.annual-general {
  padding: 10px 16px 0 16px;
  background: #f7f9fb;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  .annual-general-title {
    margin-top: 6px;
    margin-bottom: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .all-tabs-date {
    width: 100%;
    height: 47px;
    border-bottom: 1px solid #e7e9eb;
    display: flex;
    justify-content: space-between;
    background: rgb(247, 249, 251);
    .wrap-tabs {
      // width: 300px;
      height: 100%;
      // margin-left: 16px;
      display: flex;
      .el-tabs__nav-wrap::after {
        display: none !important;
      }
    }
    .right-data-btns {
      line-height: 47px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      .buttons-style {
        display: inline-block;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        cursor: pointer;
        &.active {
          @apply text-theme;
        }
        & + .buttons-style {
          margin-left: 10px;
        }
      }
    }
  }
  .allyear-tips {
    display: flex;
    padding-top: 16px;
    padding-bottom: 16px;
    // margin-top: 16px;
    background: #fff;
    .allyear-tips-item {
      .ml-2 {
        margin-left: 0px;
        font-size: 14px;
      }
      flex: 1;
      height: 60px;
      border-right: 1px solid #d9dde0;
      padding-left: 40px;
      .item-tips {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        .tips-nums {
          font-weight: bold;
          font-size: 20px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 24px;
          margin-top: 4px;
          width: 80%;
          text-overflow: ellipsis;
          height: 24px;
          overflow: hidden;
          white-space: nowrap;
        }
        .tips-supplement {
          color: #e8a31b;
          font-size: 12px;
        }
      }
      &:last-child {
        border-right: 0;
      }
    }
  }
  .allyear-table {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .charts-table {
    margin-top: 16px;
    width: 100%;
    height: 334px;
    background: #fff;
    display: flex;
    padding: 16px;
    box-sizing: border-box;
    .charts-box {
      // flex: 1;
      width: 450px;
    }
    .table-box {
      flex: 1;
      margin-left: 15px;
      width: calc(50% - 15px);
    }
  }
  .table-list {
    .table-box-items {
      // padding: 16px;
      // background: #fff;
      margin-top: 16px;
    }
  }
  .wrap-box-tips {
    // box-shadow: 0 1px 4px 0 rgba(0,0,0,0.06);
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
